module.exports = __webpack_public_path__ + "img/602x698 Rental Car.e470cb4b.jpg";